<template>
  <help-dialog title="Chat Log (BETA)">
    <template #default>
      <h3 class="mb-1 text-black">
        <span class="bg-grey-lighten-3">Chat with your Workflow Assistant</span>
      </h3>
      <p class="text-grey-darken-3">
        Keep track of every step in your workflow journey. Ask questions, get instant AI‑powered suggestions, and see
        real‑time updates right here in this chat log. All of your prompts, AI responses, and automated function‑calls
        are saved chronologically, so you can review decisions, audit changes, and pick up right where you left off.
        Whether you’re brainstorming improvements, creating events, or restructuring lanes, our assistant is here to
        guide you every step of the way.
      </p>
      <br />
      <p class="text-grey-darken-3">
        <b>Note:</b> This feature is currently in beta. We’re actively adding new actions and
        capabilities. Check back soon for even more automation options!
      </p>
      <br />
      <h4 class="mb-1 text-black">Available actions</h4>
      <ul class="ml-5">
        <li v-for="action in availableActions" :key="action">
          <b>{{ action }}</b>
        </li>
      </ul>
    </template>
  </help-dialog>
</template>

<script setup>
import HelpDialog from '@/components/HelpDialog.vue'

const availableActions = [
  'Create event',
  'Update event description',
  'Delete event',
  'Update workflow name',
  'Create lane',
  'Update lane name',
  'Delete lane',
  'Move lane',
  'Create card',
  'Delete card',
  'Update card description',
  'Vote card',
  'Create/update/delete entity',
  'Create command'
]

</script>
